import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  CcdlButtonComponent,
  CcdlInputComponent,
  CcdlLinkComponent,
  ErrorConfig,
} from '@cpm-pr1618001/ng-design-lib';
import { Subscription } from 'rxjs';

@Component({
  selector: 'forgot-password-ui',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss'],
  imports: [
    ReactiveFormsModule,
    CcdlButtonComponent,
    CcdlInputComponent,
    CcdlLinkComponent,
  ],
  standalone: true,
})
export class ForgotPasswordComponent implements OnInit, OnChanges, OnDestroy {
  @Input() fpForm!: FormGroup;
  @Input() isOTPRequested: boolean;
  @Input() isSubmitTriggered: boolean = false;

  @Output() resetPasswordSubmitEmitter: EventEmitter<void> =
    new EventEmitter<void>();

  @Output() requestOTPEmitter = new EventEmitter<string>();

  @Output() cancelEmitter = new EventEmitter<void>();

  subscription: Subscription = new Subscription();
  emailErrorConfig: ErrorConfig = {
    required: 'Email address is required.',
    pattern: 'Please enter a valid email address.',
  };
  resetErrorConfig: ErrorConfig = {
    required: 'OTP is required.',
    pattern: 'OTP must be exactly 6 digits.',
  };
  passwordErrorConfig: ErrorConfig = {
    required: 'Password is required.',
    minlength: 'Password must be at least 8 characters.',
    uppercase: 'Must contain at least one uppercase letter.',
    lowercase: 'Must contain at least one lowercase letter.',
    digit: 'Must contain at least one number.',
    special: 'Must contain at least one special character (@$!%*#?&).',
  };
  confirmPasswordErrorConfig: ErrorConfig = {
    required: 'Please confirm your password.',
    minlength: 'Password must be at least 8 characters.',
    uppercase: 'Must contain at least one uppercase letter.',
    lowercase: 'Must contain at least one lowercase letter.',
    digit: 'Must contain at least one number.',
    special: 'Must contain at least one special character (@$!%*#?&).',
    mismatch: 'Passwords do not match.',
  };
  isValidOTP: boolean = false;
  isHaveOTP: boolean = false;
  savedInitialEmail: string | null = null;
  requesteEmail: string;
  constructor() {}

  get resetOTPControl(): FormControl {
    return this.getControl('resetOTP');
  }

  get emailControl(): FormControl {
    return this.getControl('email');
  }
  ngOnInit(): void {
    this.subscription.add(
      this.resetOTPControl.valueChanges.subscribe(() => {
        this.isValidOTP = this.resetOTPControl.valid;
      }),
    );

    this.subscription.add(
      this.getControl('newPassword').valueChanges.subscribe(() => {
        this.getControl('confirmPassword').updateValueAndValidity();
      }),
    );
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.isOTPRequested?.currentValue && this.emailControl) {
      this.formatRequestedEmail();
    }
  }

  getControl(controlName: string): FormControl {
    return this.fpForm.get(controlName) as FormControl;
  }

  requestOTP(): void {
    this.requestOTPEmitter.emit(this.emailControl.value);
  }

  formatRequestedEmail(): void {
    this.requesteEmail;
    const email: string = this.emailControl.value || '';
    const atIndex: number = email.indexOf('@');
    this.requesteEmail = email.substring(atIndex - 3, email.length);
  }

  haveOTPClick(): void {
    this.savedInitialEmail = this.emailControl.value;
    this.getControl('email').reset();
    this.isHaveOTP = true;
  }

  cancelFlow1Click(): void {
    this.getControl('resetOTP').reset();
    this.getControl('newPassword').reset();
    this.getControl('confirmPassword').reset();
    this.isValidOTP = false;
    this.cancelEmitter.emit();
  }

  cancelFlow2Click(): void {
    this.getControl('email').setValue(this.savedInitialEmail ?? null);
    this.savedInitialEmail = null;
    this.getControl('resetOTP').reset();
    this.getControl('newPassword').reset();
    this.getControl('confirmPassword').reset();
    this.isValidOTP = false;
    this.isHaveOTP = false;
  }

  resetPasswordClick(): void {
    this.resetPasswordSubmitEmitter.emit();
  }

  ngOnDestroy(): void {}
}
